import type { RecipeTypeRow } from "@/hooks/useGetRecipeTypes";
import { ListBox, Select } from "@heroui/react";
import { Controller, type Control } from "react-hook-form";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import { FilterFieldShell } from "./FilterFieldShell";

interface RecipeTypeFilterProps {
    control: Control<RecipesFilterFormValues>;
    recipeTypes: RecipeTypeRow[];
    onApply(): void;
}

export const RecipeTypeFilter = ({ control, recipeTypes, onApply }: RecipeTypeFilterProps) => {
    return (
        <FilterFieldShell label="Type">
            <Controller
                name="recipeTypeNames"
                control={control}
                render={({ field }) => {
                    const values = (field.value as string[]) ?? [];

                    return (
                        <Select
                            className="w-full"
                            variant="secondary"
                            selectionMode="multiple"
                            placeholder="Any"
                            value={values}
                            onChange={(keys) => {
                                field.onChange(keys as string[]);
                                queueMicrotask(onApply);
                            }}
                            aria-label="Recipe type"
                        >
                            <Select.Trigger className="w-full">
                                <Select.Value>
                                    {({ defaultChildren, isPlaceholder, state }) => {
                                        const items = state.selectedItems;
                                        if (isPlaceholder || items.length === 0) return defaultChildren;
                                        if (items.length === 1) return items[0]?.textValue ?? defaultChildren;
                                        return `${items.length} selected`;
                                    }}
                                </Select.Value>
                                <Select.Indicator />
                            </Select.Trigger>
                            <Select.Popover>
                                <ListBox selectionMode="multiple">
                                    {recipeTypes.map((type) => (
                                        <ListBox.Item key={type.name} id={type.name} textValue={type.name}>
                                            {type.name}
                                            <ListBox.ItemIndicator />
                                        </ListBox.Item>
                                    ))}
                                </ListBox>
                            </Select.Popover>
                        </Select>
                    );
                }}
            />
        </FilterFieldShell>
    );
};
